// home.js
import React from 'react';
import { useSelector } from 'react-redux';
import config from '../../../../config/config';
import CustomList from '../Util/List/CustomList/CustomList'
import CustomListContainer from '../Util/List/CustomList/CustomListContainer'

import '../home/Home.css';

const Balance = (props) => {
  const sessionSelector = useSelector((state) => { return state.core.session });
  const friendly_url = sessionSelector.pdc_project_friendly_url;

  const pathsBalance = {
    endpoint: config.endpoints.backend + 'portal/getallbalance'
  }
  const listBalance = {
    labelTitle: 'Balanço',
    icon: 'fa-newspaper',
    filter: {
      friendly_url
    },
    canDownload: true,
    fieldToDownload: 'file',
    columns: [
      {
        name: 'demonstrative_type',
        label: 'Tipo de Demonstrativo'
      },
      {
        name: 'publish_date',
        label: 'Data Base'
      },
      {
        name: 'obs',
        label: 'Descrição'
      }
    ]
  };
  
  return (
    <CustomListContainer
    canAdd={false}
      labelTitle={listBalance.labelTitle}
      icon={listBalance.icon}
      content={<CustomList list={{ ...listBalance, ...pathsBalance }} />}
      />
      );
    };
    
    export default Balance;
    